import React, { useState, useEffect } from 'react';

const AnimatedImage = ({ src, index, title, isMobile, skipAnimation }) => {
  const [loaded, setLoaded] = useState(skipAnimation);

  useEffect(() => {
    if (skipAnimation) return;
    const timer = setTimeout(() => {
      setLoaded(true);
    }, 100 * index);
    return () => clearTimeout(timer);
  }, [index, skipAnimation]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '10px 0',
      width: '100%',
    }}>
      <img
        src={src}
        alt={title}
        style={{
          maxWidth: isMobile ? '90%' : '65%',
          maxHeight: '80vh',
          width: '100%',
          marginTop: isMobile ? '-2%' : '0',
          marginLeft: isMobile ? '-5%' : '0',
          opacity: loaded ? 1 : 0,
          transform: `translateY(${loaded ? 0 : '20px'})`,
          transition: 'opacity 0.8s ease, transform 0.8s ease',
          objectFit: 'cover',
        }}
        onLoad={() => setLoaded(true)}
      />
        <p style={{
          marginTop: '10px',
          opacity: loaded ? 1 : 0,
          transform: `translateY(${loaded ? 0 : '20px'})`,
          transition: 'opacity 0.8s ease, transform 0.8s ease',
          fontSize: '15px',
          textAlign: 'center',
          color: '#666',
        }}>
          {title}
        </p>

    </div>
  );
};
export default function Photos() {
  const skipAnimation = sessionStorage.getItem('photosAnimated') === 'true';

  useEffect(() => {
    sessionStorage.setItem('photosAnimated', 'true');
  }, []);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

   const cloudFront = "https://d2s5ye0agxvg00.cloudfront.net";

  const images = [
    { src:  `${cloudFront}/sardines_small.webp`, title: "'dines, 2026" },
    { src: `${cloudFront}/gloves.webp`, title: 'doing science, 2025' },
    { src: `${cloudFront}/chicken.webp`, title: 'love language, 2018' },
    { src: `${cloudFront}/swallows_nest.webp`, title: 'nest, 2025' },
    { src: `${cloudFront}/mini_golf.webp`, title: 'mummification, 2025' },
    { src: `${cloudFront}/serres.webp`, title: 'substantial foods and sonorous voices, 2019' },
  ];

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 900);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      overflowX: 'hidden',
      overflowY: 'visible',
      height: 'auto',
      padding: isMobile ? '20px' : '40px 0',
      width: isMobile ? 'auto' : '85%',
      marginLeft: isMobile ? '2%' : 'auto',
      marginRight: isMobile ? '0' : 'auto',
    }}>
      {images.map((image, index) => (
        <AnimatedImage
          key={image.src}
          src={image.src}
          title={image.title}
          index={index}
          isMobile={isMobile}
          skipAnimation={skipAnimation}
        />
      ))}
    </div>
  );
}